import View from '@shared/components/layout-default/layout-default-router-view';

export const autocaller_v2 = [
  {
    path: '/predictive',
    component: View,
    children: [
      {
        path: '',
        name: 'autocaller_v2.module',
        redirect: {
          name: 'autocaller_v2.campaign.index'
        }
      },
      {
        path: 'stats',
        component: View,
        children: [
          {
            path: '',
            name: 'autocaller_v2.stats.index',
            redirect: {
              name: 'autocaller_v2.stats.type',
              params: {
                type: 'detailed'
              }
            }
          },
          {
            path: ':type(general|detailed)',
            name: 'autocaller_v2.stats.type',
            component: () =>
              import(
                /* webpackChunkName: 'autocaller' */
                '@autocaller_v2/pages/campaigns-stats-page'
              ),
            meta: {
              title: {
                code: 'shared.breadcrumb.stats.title'
              }
            }
          }
        ]
      },
      {
        path: 'campaigns',
        component: View,
        children: [
          {
            path: '',
            name: 'autocaller_v2.campaign.index',
            meta: {
              title: { code: 'autocaller_v2.breadcrumb.campaign.index' }
            },
            component: () =>
              import(
                /* webpackChunkName: "autocaller" */ '@autocaller_v2/pages/campaigns-list-page'
              )
          },
          {
            path: 'new',
            name: 'autocaller_v2.campaign.new',
            meta: {
              title: { code: 'autocaller_v2.breadcrumb.campaign.new' },
              permissions: ['module_pbx_is_allowed']
            },
            component: () =>
              import(
                /* webpackChunkName: "autocaller" */ '@autocaller_v2/pages/campaigns-create-page'
              )
          },
          {
            path: ':id([\\d]*)/edit',
            name: 'autocaller_v2.campaign.edit',
            meta: {
              title: { code: 'autocaller_v2.breadcrumb.campaign.edit' },
              loadable: true,
              permissions: ['module_pbx_is_allowed']
            },
            component: () =>
              import(
                /* webpackChunkName: "autocaller" */ '@autocaller_v2/pages/campaigns-edit-page'
              )
          },
          {
            path: ':id([\\d]*)/tasks',
            name: 'autocaller_v2.task.index',
            meta: {
              title: { code: 'autocaller_v2.breadcrumb.task.index' }
            },
            component: () =>
              import(/* webpackChunkName: "autocaller" */ '@autocaller_v2/pages/task-list-page')
          },
          {
            path: ':id([\\d]*)/monitoring',
            name: 'autocaller_v2.monitoring.index',
            meta: {
              title: { code: 'autocaller_v2.breadcrumb.monitoring.index' }
            },
            component: () =>
              import(
                /* webpackChunkName: "autocaller" */ '@autocaller_v2/pages/monitoring-list-page'
              )
          }
        ]
      },
      // {
      //   path: 'webhooks',
      //   component: View,
      //   children: [
      //     {
      //       path: '',
      //       name: 'autocaller_v2.webhooks.index',
      //       meta: {
      //         title: { code: 'autocaller_v2.breadcrumb.webhook.index' }
      //       },
      //       component: () =>
      //         import(/* webpackChunkName: "autocaller" */ '@autocaller_v2/pages/webhook-list-page')
      //     }
      //   ]
      // },
      {
        path: 'settings',
        component: View,
        children: [
          {
            path: '',
            name: 'autocaller_v2.stats.index',
            redirect: {
              name: 'autocaller_v2.stats.type',
              params: {
                type: 'detailed'
              }
            }
          },
          {
            path: ':type(webhook|products)',
            name: 'autocaller_v2.settings.type',
            component: () =>
              import(
                /* webpackChunkName: 'autocaller' */
                '@autocaller_v2/pages/settings-list-page'
              ),
            meta: {
              title: {
                code: 'autocaller_v2.breadcrumb.settings.index'
              }
            }
          }
        ]
      },


      {
        path: 'monitoring',
        component: View,
        children: [
          {
            path: '',
            name: 'autocaller_v2.monitoring_general.index',
            meta: {
              title: { code: 'autocaller_v2.breadcrumb.monitoring_general.index' }
            },
            component: () =>
              import(
                /* webpackChunkName: "autocaller" */ '@autocaller_v2/pages/monitoring-general-page'
              )
          }
        ]
      },
      {
        path: 'operators',
        component: View,
        children: [
          {
            path: '',
            name: 'autocaller_v2.operators.index',
            meta: {
              title: { code: 'autocaller_v2.breadcrumb.operators.index' }
            },
            component: () =>
              import(
                /* webpackChunkName: "autocaller" */ '@autocaller_v2/pages/operators-list-page'
              )
          }
        ]
      }
    ],
    meta: {
      permissions: ['module_predictive_is_allowed']
    }
  }
];
